/**
 * Vue Filter - option value
 */

/**
 * Display the guideline option value with a prefix.
 * @param {number} val Number
 * @param {boolean} usePref Use prefix.
 */
export default function optionValue(option) {
	if (!option) return 0
	if (option.type == 'base' || option.type == 'alternate') return option.value
	if (option.maxValue && option.value == 0) return `${option.maxValue}`
	if (option.minValue && option.value == 0) return `${option.minValue}`
	// if (option.minValue && option.value == 0) return `↧${option.minValue}`
	// if (option.maxValue && option.value == 0) return `↥${option.maxValue}`
	if (option.value && Number(option.value) > 0) return `+${option.value}`
	return option.value
	// return val == 1 ? `${val} ${suffix}` : `${val} ${suffix}s`
}
